module.exports = __webpack_public_path__ + "img/8.2376af4a.jpg";